///////////////////////////////////////////////////////////////////////////////
// Card expiry input — format as the customer types, parse for tokenizing.
//
// The iOS number pad (inputMode="numeric") has no '/' key, so the field must
// insert it: '0828' → '08/28'. A leading 2-9 can only be a one-digit month
// ('828' → '08/28'), and '8/28' typed on a keyboard keeps its month too.
// Autofill (cc-exp) may hand over a 4-digit year ('08/2028'), so up to 6
// digits are kept. Plain JS (no DOM) so it is unit-testable. See GitLab #238.
///////////////////////////////////////////////////////////////////////////////

export function formatExpiry(raw) {
  let v = String(raw || '').replace(/[^\d/]/g, '');
  if (/^\d\//.test(v)) v = `0${v}`;
  let d = v.replace(/\D/g, '');
  if (/^[2-9]/.test(d)) d = `0${d}`;
  d = d.slice(0, 6);
  return d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d;
}

// { month: '08', year: '2028' }, or null when it isn't MM/YY or MM/YYYY.
export function parseExpiry(value) {
  const m = String(value || '').trim().match(/^(\d{2})\s*\/\s*(\d{2}|\d{4})$/);
  if (!m) return null;
  return { month: m[1], year: m[2].length === 2 ? `20${m[2]}` : m[2] };
}
